import { DateTime } from 'luxon';
import { ParkerRegistrationOffense, ParkingProcessTariffInfoDTO } from 'src/app/base/models/models.swagger.generated';
import { ParkingTimeRange } from './parking-time-range';

export class ParkingSessionTimeSlice
{
  public timeRange: ParkingTimeRange;
  public tariff: ParkingProcessTariffInfoDTO;
  public offense = ParkerRegistrationOffense.NoOffense;

  public constructor(startTime: DateTime)
  {
      this.timeRange = new ParkingTimeRange(startTime);
  }
}
